import { QueryClient } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { GENERAL_QUERY_CACHE_TIME, GENERAL_QUERY_STALE_TIME } from "Shared/queries/consts"

const MAX_RETRIES = 2
const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404]

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: GENERAL_QUERY_STALE_TIME,
            cacheTime: GENERAL_QUERY_CACHE_TIME,
            retry: (failureCount, error) => {
                if (failureCount > MAX_RETRIES) {
                    return false
                }

                if (isAxiosError(error) && error?.response?.status && HTTP_STATUS_TO_NOT_RETRY.includes(error.response.status)) {
                    return false
                }

                return true
            },
        },
    },
})
